import { IBuyPackageModalState } from './types';
import { EBuyPackageStatus, EInternalPackageType } from '../../types/packages';

export const initialState: IBuyPackageModalState = {
  isVisible: false,
  status: EBuyPackageStatus.Confirm,
  message: undefined,
  data: {
    internalType: EInternalPackageType.Subscription,
    price: 0,
    marketingPrice: null,
    auctionPoints: null,
    cashback: null,
    cashbackPercent: null,
    discountPercent: null,
    categoriesView: '',
    regionNames: [],
    activationDate: '',
    services: [],
    endDate: '',
    durationInDays: 0,
    autoProlong: false,
    autoProlongAvailable: false,
    totalAuctionPoints: 0,
  },
  isLoading: false,
};
